import { Field, TextOutput } from 'Components/Core';
import { NamePrefixModifier, withInjectedProps } from 'Components/Core/InjectedPropsContext';
import { ListFieldSection, PageSection } from 'Components/Layout';
import { WorksheetEquipmentDropdown } from 'Components/Worksheets/Core';
import { IWorksheetComponent } from 'Components/Worksheets/Core/types';
import { StateOfMaterial } from 'Components/Worksheets/PsdSieveAnalysisWorksheet/types';
import { SieveSizeId, createSieveSizeCaptionGetter, createSieveSizeGetter } from 'Data/ViewModels/Equipment/ISieveSize';
import { valueOrDefault } from 'Lib/Any';
import { pipe } from 'Lib/Hooks/Selectors';
import deepEquals from 'Lib/Object/deepEquals';
import React from 'react';
import { useSelector } from 'react-redux';
import InitialSeparationPredriedSection from './InitialSeparationPredriedSection';
import InitialSeparationWetMaterialSection from './InitialSeparationWetMaterialSection';

let InitialSeparationPageSection: React.FC<IWorksheetComponent> = ({ createWorksheetSelector }) => {
  const stateBeforePreparation: StateOfMaterial = useSelector(
    createWorksheetSelector!('Masses.StateAfterMassDetermination')
  );
  const separatingSieveSizeId: SieveSizeId = useSelector(createWorksheetSelector!('Separation.SeparatingSieveSizeId'));
  const separatingSieveSize = useSelector(
    pipe(
      createWorksheetSelector!('data.Equipment.AllSieveSizes', false),
      createSieveSizeGetter(separatingSieveSizeId),
      (s) => s?.Size
    ),
    deepEquals
  );
  const separatingSieveSizeCaption = useSelector(
    pipe(
      createWorksheetSelector!('data.Equipment.AllSieveSizes', false),
      createSieveSizeCaptionGetter(separatingSieveSizeId),
      valueOrDefault('N/A')
    )
  );

  //Pre-dried material - dry mass is measured, no wet mass or moisture content test
  const preDriedMaterial = stateBeforePreparation === StateOfMaterial.OvenDry;
  return (
    <PageSection heading="Initial Separation">
      <NamePrefixModifier appendNamePrefix="Separation">
        <ListFieldSection>
          <Field input={<TextOutput />} name="SeparatingSieveSizeId" value={separatingSieveSizeCaption} />
          <Field
            input={<WorksheetEquipmentDropdown />}
            name="SeparatingSieve"
            label="Separating Sieve"
            equipmentType="sieve"
            queryParams={{ SieveSize: `${separatingSieveSize?.value} ${separatingSieveSize?.uom}` }}
          />
        </ListFieldSection>
      </NamePrefixModifier>

      {preDriedMaterial ? <InitialSeparationPredriedSection /> : <InitialSeparationWetMaterialSection />}
    </PageSection>
  );
};
InitialSeparationPageSection = withInjectedProps(InitialSeparationPageSection);

export { InitialSeparationPageSection };
export default InitialSeparationPageSection;
